import {
  GetRiskProfilesResponse,
  RiskProfile,
  RiskProfileResponse,
} from '@/api';
import { RiskscoreProfilesData } from '../models';

const listRiskProfiles = (
  response: GetRiskProfilesResponse,
): RiskscoreProfilesData => {
  const { data } = response;
  return data;
};

const riskProfile = (response: RiskProfileResponse): RiskProfile => {
  const { profile } = response.data;
  return profile;
};

export { listRiskProfiles, riskProfile };
